import { usePersistStore } from './store';

export const getPersistStore = () => {
    const persistState = usePersistStore.getState();
    return persistState;
};

const url = {
    vivaApi: () => {
        return import.meta.env.VITE_AIDT_URL_VIVA;
    },
    vCloudApi: () => {
        return import.meta.env.VITE_AIDT_URL_LMSAPI;
    },
    lCmsApi: () => {
        return import.meta.env.VITE_AIDT_URL_LCMSAPI;
    },
    medianaviApi: () => {
        return import.meta.env.VITE_AIDT_URL_FEEDBACK;
    },
    // kerisApi: () => {
    //     if (!validate.isEmptyString(getUserState().sKerisDomain)) {
    //         return getUserState().sKerisDomain;
    //     }
    //     return getUserState().sIsKeris ? import.meta.env.VITE_AIDT_KERIS_API : url.vCloudApi();
    // },
    vViewrPatnerId: () => {
        return import.meta.env.VITE_VIEWER_PARTNER_ID;
    },
    src: (filepath?: string) => {
        if (filepath == undefined) return '';
        const isHttp = filepath?.startsWith('http') || filepath?.startsWith('https');
        const isBase64 = filepath?.startsWith('data:image');

        const searchString = '/files/nas';
        if (isBase64) {
            return filepath;
        } else if (isHttp && filepath.includes(searchString)) {
            return filepath + '&jwtToken=' + getPersistStore().sToken;
        } else if (isHttp) {
            return filepath;
        } else if (filepath.includes(searchString)) {
            return (
                url.vCloudApi() +
                '/files/pfile-download/?url=' +
                filepath +
                '&jwtToken=' +
                getPersistStore().sToken
            );
        } else {
            return import.meta.env.VITE_URL_CMS + '/' + filepath;
        }
    },
    getLocationHashPath: () => {
        const hash = location.hash || '';
        if (hash.indexOf('#') == 0) {
            return hash.substring(1);
        }
        return undefined;
    },
};

export default url;
